export default __webpack_public_path__ + "fonts/high-equity.svg";